import Vue from "vue";
import router from "@/router";

import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "UA-77115320-1", // Google Tag Manager Tracking Id, for Vanfax
  router
});
